export enum ClientPrescriberTaskStatus {
  open = 'open',
  closed = 'closed',
  accepted = 'accepted',
  rejected = 'rejected',
}
